import React from 'react';
import { Box } from '@mui/system';
import { styled } from '@mui/material/styles';
import { Toolbar } from '@mui/material';

const CustomToolbar = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  // background: 'red',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

// mui 툴바 이용시 툴바 사이즈와 동일한 패딩이 필요한 경우 사용. 툴바 기본 설정 변경시 툴바 패더의 기본설정이 함께 변동되므로 높이 조절에 신경쓰지 않아도 됨
export const ToolbarPadder = () => {
  // return <Toolbar aria-label='padder' />;
  return <CustomToolbar aria-label='padder' />;
};
